module.exports = __webpack_public_path__ + "img/xodykin.0dbe6cca.jpg";